import { useEffect } from "react";

// Global Alt+S ("Super Search") hotkey. The legacy ASP app used Ctrl+S (see
// UtilKeyboardCommon.asp, case 83, and its own preventDefault() to reclaim
// the combo from the browser's native "Save Page As"). This React app
// deliberately remaps the shortcut to Alt+S (Cmd+S on Mac) instead of
// fighting the browser for Ctrl+S — do not "fix" this back to ctrlKey.
//
// Mount this once at the app shell level (App.jsx) so the shortcut works
// from any authenticated screen, not per-page.
const useSuperSearchShortcut = (onTrigger, { enabled = true } = {}) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event) => {
      const key = event.key?.toLowerCase();
      const isSaveCombo = (event.altKey || event.metaKey) && key === "s";
      if (!isSaveCombo) return;

      event.preventDefault();
      onTrigger?.();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onTrigger, enabled]);
};

export default useSuperSearchShortcut;
